<div class="column gap center">
  <div class="header">
    <img
      [src]="currentCustomer?.logoUrlBase + 'login-logo.svg'"
      [alt]="'logo-' + currentCustomer?.domain"
    />
    <span *ngIf="currentCustomer?.domain === securityDomain">{{ currentCustomer?.name }}</span>
  </div>
  <div class="main-container">
    <h3>Reset password</h3>
    <p>
      Enter your email to reset your password. You will receive an email with instructions on how to set a new one.
    </p>
  </div>
  <div>
    <form [formGroup]="emailResetPasswordForm" (ngSubmit)="resetPassword()">
      <div class="column gap-sm">
        <mat-form-field>
          <input matInput placeholder="email" type="email" formControlName="email" name="email" required/>
        </mat-form-field>
        <button type="submit" mat-raised-button [disabled]="emailResetPasswordForm.invalid">Reset password</button>
      </div>
    </form>
  </div>
</div>
